import { Alert, Box, Button, FormControl, Grid, MenuItem } from "@mui/material";
import ttData from "../../data/ttHistoricalLineData.json";
import rtmData from "../../data/rtmHistoricalStationData.json";
import { StyledInputLabel, StyledSelect } from "../FormElements/CustomSelect";
import { useEffect, useState } from "react";
import ttMetricsService from "../../services/TTMetricsService";
import Loader from "../Loader/Loader";
import MetricsTable from "../MetricsTable/MetricsTable";
import rtmMetricsService from "../../services/RTMMetricsService";

function MetricsFotTTAndRTM({ organisation }) {
  const [values, setValues] = useState({ id: "", frequency: "" });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [metrics, setMetrics] = useState([]);
  const [type, setType] = useState("");

  const onGetMetrics = (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ show: false, type: "", message: "" });
    setMetrics([]);
    if (organisation === "TT") {
      ttMetricsService
        .getMetrics(values.id, { frequency: values.frequency })
        .then(({ data }) => {
          if (data.length > 0) {
            setMetrics(data);
            setAlert({ show: false, type: "", message: "" });
          } else {
            setAlert({
              show: true,
              type: "info",
              message: "There are no available metrics data at the moment.",
            });
            setMetrics([]);
          }
        })
        .catch((error) => {
          setAlert({
            show: true,
            type: "error",
            message: "Failed to fetch metrics data. Try again later.",
          });
          setMetrics([]);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      if (type === "line") {
        rtmMetricsService
          .getLineMetrics(values.id, { frequency: values.frequency })
          .then(({ data }) => {
            if (data.length > 0) {
              setMetrics(data);
              setAlert({ show: false, type: "", message: "" });
            } else {
              setAlert({
                show: true,
                type: "info",
                message: "There are no available metrics data at the moment.",
              });
              setMetrics([]);
            }
          })
          .catch((error) => {
            setAlert({
              show: true,
              type: "error",
              message: "Failed to fetch metrics data. Try again later.",
            });
            setMetrics([]);
          })
          .finally(() => {
            setLoading(false);
          });
      } else if (type === "station") {
        rtmMetricsService
          .getStationMetrics(values.id, { frequency: values.frequency })
          .then(({ data }) => {
            if (data.length > 0) {
              setMetrics(data);
              setAlert({ show: false, type: "", message: "" });
            } else {
              setAlert({
                show: true,
                type: "info",
                message: "There are no available metrics data at the moment.",
              });
              setMetrics([]);
            }
          })
          .catch((error) => {
            setAlert({
              show: true,
              type: "error",
              message: "Failed to fetch metrics data. Try again later.",
            });
            setMetrics([]);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    setMetrics([]);
    setValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const timePeriods = [
    { id: "daily_short", name: "Daily short" },
    { id: "daily_long", name: "Daily long" },
    { id: "monthly", name: "Monthly" },
  ];

  useEffect(() => {
    setMetrics([]);
    setValues((prevValues) => ({ ...prevValues, id: "" }));
  }, [type]);
  return (
    <div id="resource-list-wrapper">
      <div className="dashChart">
        <form onSubmit={onGetMetrics}>
          <div className="flexBox">
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12} md={12}>
                  <div
                    className="chartBox chartOptions flex-column"
                    style={{ gap: "16px", alignItems: "flex-start" }}
                  >
                    <h2 className="grafanaTitle">Metrics</h2>
                    <p>
                      Choose the desired categories & frequency from the options
                      below to get the corresponding metrics.{" "}
                    </p>
                    <div className="dashChart flexBox">
                      {organisation === "TT" && (
                        <OptionsForTT
                          handleChange={handleChange}
                          values={values}
                        />
                      )}
                      {organisation === "RTM" && (
                        <OptionsForRTM
                          handleChange={handleChange}
                          values={values}
                          setValues={setValues}
                          type={type}
                          setType={setType}
                        />
                      )}
                      <FormControl fullWidth={true}>
                        <StyledInputLabel htmlFor={`frequency`}>
                          Frequency
                        </StyledInputLabel>
                        <StyledSelect
                          labelId={`frequency`}
                          label={"Frequency"}
                          required
                          name="frequency"
                          onChange={handleChange}
                          value={values.frequency}
                        >
                          <MenuItem value=""></MenuItem>
                          {timePeriods.map((item, index) => (
                            <MenuItem key={`${index}`} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </StyledSelect>
                      </FormControl>
                    </div>
                    <br />
                    <div className="dashChart">
                      <FormControl size="small" fullWidth={true}>
                        <div className="flexBox flexEnd">
                          <Button
                            variant="contained"
                            size="medium"
                            type="submit"
                          >
                            Get metrics
                          </Button>
                        </div>
                      </FormControl>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
        </form>
      </div>
      {loading && <Loader transparent={true} />}
      {alert.show && (
        <div className="flexBox flexCenter">
          <Alert severity={alert.type}>{alert.message}</Alert>
        </div>
      )}
      {metrics.map((item, index) => (
        <div className="dashChart" key={index}>
          <h3 className="metrics-title">Metrics</h3>
          <div className="chartBox">
            <MetricsTable metrics={item.metrics} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default MetricsFotTTAndRTM;

function OptionsForTT({ handleChange, values }) {
  return (
    <FormControl fullWidth={true}>
      <StyledInputLabel htmlFor={`line-select`}>Line</StyledInputLabel>
      <StyledSelect
        labelId={`line-select`}
        label={"Line"}
        required
        name="id"
        onChange={handleChange}
        value={values.id}
      >
        <MenuItem value=""></MenuItem>
        {ttData.map((item, index) => (
          <MenuItem key={`${index}`} value={item.line_id}>
            {item.line_name_index}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}

function OptionsForRTM({ handleChange, values, setValues, type, setType }) {
  const lineData = rtmData.filter(
    (obj, index, self) => index === self.findIndex((t) => t.line === obj.line)
  );

  return (
    <>
      <FormControl fullWidth={true}>
        <StyledInputLabel htmlFor={`type-select`}>Type</StyledInputLabel>
        <StyledSelect
          labelId={`type-select`}
          label={"Type"}
          required
          name="type"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <MenuItem value=""></MenuItem>
          <MenuItem value="line">Line</MenuItem>
          <MenuItem value="station">Station</MenuItem>
        </StyledSelect>
      </FormControl>
      {type === "line" && (
        <FormControl fullWidth={true}>
          <StyledInputLabel htmlFor={`line-select`}>Line</StyledInputLabel>
          <StyledSelect
            labelId={`line-select`}
            label={"Line"}
            required
            name="id"
            onChange={handleChange}
            value={values.id}
          >
            <MenuItem value=""></MenuItem>
            {lineData.map((item, index) => (
              <MenuItem key={`${index}`} value={item.line}>
                {item.line}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      )}
      {type === "station" && (
        <FormControl fullWidth={true}>
          <StyledInputLabel htmlFor={`station-select`}>
            Station
          </StyledInputLabel>
          <StyledSelect
            labelId={`station-select`}
            label={"Station"}
            required
            name="id"
            onChange={handleChange}
            value={values.id}
          >
            <MenuItem value=""></MenuItem>
            {rtmData.map((item, index) => (
              <MenuItem key={`${index}`} value={item.station_id}>
                {item.station_name}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      )}
    </>
  );
}
